var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"brand-logo",attrs:{"to":"/"}},[(!_vm.domainBasedBrand)?_c('div',[_c('img',{staticClass:"img-fluid light-logo",attrs:{"src":"/images/logo-w.png","alt":""}})]):_c('div',[_c('img',{staticClass:"img-fluid logo-image-header short-logo",style:({
        borderRadius:
          _vm.currentBrand.web_logo_issqr && _vm.$route.name === 'home'
            ? '50%'
            : null,
      }),attrs:{"src":_vm.currentBrand.web_logo_issqr
          ? _vm.currentBrand.web_logo_sqr
          : _vm.currentBrand.web_logo}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }